module.exports = "/packs/images/svg/alert-high~76e6eaf40e1156a5c0a2f608b70a95a6.svg";